import React, { useEffect } from 'react'
import styles from './Home.module.css'
import ResourcesButton from './ResourcesButton';
import Button from '@material-ui/core/Button';
import { NavHashLink  } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { useStateValue } from '../../StateProvider';


function Home() {
    const [{loggedIn,currentPage}, dispatch] = useStateValue()

    useEffect(() => {
        dispatch({
            type: 'UPDATE_PAGE',
            page: "home"
        })
    }, [])
    

    return (
        <div className={styles.component}>
            <div className={styles.canvas}>
                <div className={styles.text}>
                    
                    <h1>India Fights Against Covid-19</h1>
                    <p>Let us all survive this together! Please donate plasma as much as possible, your donation might help someone clinge on to life.</p>

                    <div className={styles.resources}>
                        <ResourcesButton title="Plasma" icon="fas fa-tint" linkPath="/Plasma"/>
                        <ResourcesButton title="Helplines" icon="fas fa-ambulance" linkPath="/ambulance-help"/>
                        <ResourcesButton title="Oxygen" icon="fas fa-head-side-mask" linkPath="/Oxygen"/>
                        <ResourcesButton title="Beds" icon="fas fa-bed" linkPath="/Beds"/>
                        <ResourcesButton title="Remdesivir" icon="fas fa-capsules" linkPath="/Remdesivir"/>
                        <ResourcesButton title="Food" icon="fas fa-utensils" linkPath="/Food"/>
                        
                    </div>
                    <div className={styles.otherSec}>
                        <NavHashLink smooth  to='#important-links' className={styles.hashLink}>
                            <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<i className='fas fa-info-circle' />}
                            className={styles.otherResources}
                            >
                                Important Links 
                            </Button>    
                        </NavHashLink>

                        <NavHashLink smooth  to='#covid19-guides' className={styles.hashLink}>
                            <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<i className='fas fa-info-circle' />}
                            className={styles.otherResources}
                            >
                                Covid-19 Guides
                            </Button>  
                        </NavHashLink>
                        
                        <Link to={(loggedIn)?'/dashboard' :'/login'} className={styles.hashLink}>
                            <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<i className='fas fa-plus' />}
                            className={styles.otherResources}
                            >
                                { (loggedIn) ? "Add Resources" : "Login to add Resources"}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className={styles.flag}/>
        </div>
    )
}

export default Home
